// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"a7c6ec25","708":"e9300c88"}[chunkId] + ".chunk.js";
};